import BonusesTab from 'pages/Desktop/Home/Manager/components/Bonuses/BonusesTab'
import { SppWlList } from '../../SppWlList/SppWlList'

export const sppTabsList = [
  {
    label: 'РЛ',
    component: SppWlList
  },
  {
    label: 'Бонусы',
    component: BonusesTab
  }
]
